import { Routes } from '@angular/router'
import { AccountSelectionComponent } from './views/account-selection/account-selection.component'
import { RegistrationComponent } from './views/registration/registration.component'
import { RegistrationSuccessComponent } from './views/registration-success/registration-success.component'
import { CompanySearchComponent } from './views/company/search/company-search.component'
import { CompanyConfirmComponent } from './views/company/confirm/company-confirm.component'
import { TopComponent } from './views/top/top.component'
import { RegistrationConfirmComponent } from './views/registration-confirm/registration-confirm.component'

export const routes: Routes = [
  {
    path: '',
    component: TopComponent,
  },
  {
    path: 'top',
    component: TopComponent,
  },
  {
    //アカウントタイプ選択'
    path: 'account-selection',
    component: AccountSelectionComponent,
  },
  {
    // アカウント情報入力,
    path: 'registration',
    component: RegistrationComponent,
  },
  {
    // 利用規約,
    path: 'registration-confirm',
    component: RegistrationConfirmComponent,
  },
  {
    // アカウント登録完了,
    path: 'registration-success',
    component: RegistrationSuccessComponent,
  },
  {
    // 会社検索,
    path: 'company-search',
    component: CompanySearchComponent,
  },
  {
    // 会社検索,
    path: 'company-confirm',
    component: CompanyConfirmComponent,
  },
]
